import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Stepper from "@material-ui/core/Stepper";
import { makeStyles } from "@material-ui/core/styles";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import axios from "../../../security/axios";

//import "./ProductSwap.css";
import Alert from "../../product-swap/alert/Alert";
import OrderTable from "./manage-order/OrderTable";
import EmailForm from "./manage-order/EmailForm";
import EditOrder from "./manage-order/EditOrder";

const useStyles = makeStyles((theme) => ({
    stepper: {
        padding: theme.spacing(3, 0, 5),
    }
}));

const FIND_ORDER_FOR_CUSTOMER = 0;
const SELECT_ORDER_TO_MODIFY = 1;
const PERFORM_ORDER_CHANGES = 2;

const steps = ['Find order via email', 'Select order to modify', 'Perform order changes'];

const OrderModify = () => {

    const [email, setEmail] = useState("");
    const [body, setBody] = useState("");
    const [changeType, setChangeType] = useState("");
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState("");
    const [activeStep, setActiveStep] = useState(FIND_ORDER_FOR_CUSTOMER);
    const [resultMessage, setResultMessage] = useState(null);
    const classes = useStyles();



    const onSubmitFindOrderCallback = async () => {
        const userOrders = await axios.get(encodeURI(`/orders?email=${email}`));
        setOrders(userOrders.data);
        setResultMessage(null);
        setActiveStep(SELECT_ORDER_TO_MODIFY);
    };

    const onConfirmOrderCallback = async () => {

        //console.log(`Update from ${oldProduct?.name} to ${newProduct?.name} finished`);
        
    };

    const getStepContent = (step) => {
        switch (step) {
            case FIND_ORDER_FOR_CUSTOMER:
                return <EmailForm
                    email={email}
                    onSubmitCallback={onSubmitFindOrderCallback}
                    onChange={setEmail} />;
            case SELECT_ORDER_TO_MODIFY:
                return <OrderTable userOrders={orders}
                    selectedOrder={selectedOrder} setSelectedOrder={setSelectedOrder}
                    onSubmitCallback={() => setActiveStep(PERFORM_ORDER_CHANGES)}
                    onBack={() => setActiveStep(activeStep - 1)} />;
            case PERFORM_ORDER_CHANGES:
                return <EditOrder selectedOrder={selectedOrder}
                    onBack={() => setActiveStep(activeStep - 1)}
                    onSubmitCallback={onConfirmOrderCallback}
                    customerEmail={email}
                    editBody={setBody}
                    editType={setChangeType} />;
            default:
                throw new Error("Unknown step");
        }
    };

    return (
        <section>
            <div className="ml-1">
                <Typography variant="h5">
                    Manage Order
                </Typography>
            </div>
            {(resultMessage && resultMessage.length > 0) && (
                <div className="mt-25 ml-1 mr-1">
                    {resultMessage.map(e =>
                        <Alert severity={e.success ? "success" : "error"} onClose={() => setResultMessage(null)}>
                            {e.msg}
                        </Alert>)
                    }
                </div>
            )}
            <div className="ml-1 mr-1 mt-25">
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className="ml-1">
                    {getStepContent(activeStep)}
                </div>
            </div>
        </section>
    );
};

export default OrderModify;